<template>
  <div class="tenant_common_info">
    <div class="contentTitle">{{ commonTitleLabel }}</div>
    <contentSection
      :titleLabel="privacyPolicyInfoLabel"
      :contentLabel="privacyPolicyContentLabel"
      :finishButtonLabel="changeButtonLabel"
      @ok="showPrivacyPolicyModal = true"
    ></contentSection>
    <contentSection
      :titleLabel="adminMailAddressTitleLabel"
      :contentLabel="adminMailAddressContentLabel"
      :finishButtonLabel="changeButtonLabel"
      @ok="showAdminMailAddressModal = true"
    ></contentSection>
    <div class="modal_window" v-if="showPrivacyPolicyModal">
      <privacyPolicyModalWindow @close="showPrivacyPolicyModal = false">
      </privacyPolicyModalWindow>
    </div>
    <div class="modal_window" v-if="showAdminMailAddressModal">
      <adminMailAddressModalWindow @close="showAdminMailAddressModal = false">
      </adminMailAddressModalWindow>
    </div>
  </div>
</template>

<script>
import contentSection from './contentSection.vue'
import privacyPolicyModalWindow from '../../modalWindow/privacyPolicyModalWindow.vue'
import adminMailAddressModalWindow from '../../modalWindow/adminMailAddressModalWindow.vue'

export default {
  data() {
    return {
      commonTitleLabel: '全体設定',
      privacyPolicyInfoLabel: 'プライバシーポリシー',
      adminMailAddressTitleLabel: '管理者メールアドレス',
      privacyPolicyContentLabel: 'プライバシーポリシーのURLを変更する',
      adminMailAddressContentLabel: '管理者メールアドレスを変更する',
      changeButtonLabel: '変更',
      showPrivacyPolicyModal: false,
      showAdminMailAddressModal: false
    }
  },
  computed: {},
  components: {
    contentSection,
    privacyPolicyModalWindow,
    adminMailAddressModalWindow
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/corporationCommonView/corporationCommonComponents/tenantCommonInfo.vue